export default __webpack_public_path__ + "static/media/dessert-drink.9d7dc471.jpg";